import * as React from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

import { Body, Button, LeftButtonWrapper, RightButtonWrapper } from './styles'

export const SubmissionButtons: React.FC<{
  onReset(): void
  disableReset?: boolean
  displayPrice?: string | undefined | null
  withPricing?: boolean
}> = ({ onReset, disableReset, displayPrice, withPricing }) => {
  const { embroidery: fixtures } = useTranslation()

  const price = displayPrice

  const isDisabled = !price || price === '0'

  return (
    <Body>
      <LeftButtonWrapper>
        <Button
          aria-label={fixtures.modal.forms.submissionButtons.resetCta}
          onClick={onReset}
          variant='ghost'
          type='button'
          aria-disabled={disableReset}
        >
          {fixtures.modal.forms.submissionButtons.resetCta}
        </Button>
      </LeftButtonWrapper>
      <RightButtonWrapper>
        {/* TODO: Replace button with anchor tag or use an actual click function. */}
        <Button
          aria-label={fixtures.modal.forms.submissionButtons.submitCta}
          onClick={() => null}
          type='submit'
          aria-disabled={isDisabled}
        >
          {fixtures.modal.forms.submissionButtons.submitCta}{' '}
          {Boolean(!isDisabled && price && withPricing) && ` +${price}`}
        </Button>
      </RightButtonWrapper>
    </Body>
  )
}
